export function assertFiniteVec2(point, name = "point") {
    if (!Number.isFinite(point.x) || !Number.isFinite(point.y)) {
        throw new RangeError(`${name} must contain finite x and y values.`);
    }
}
export function add(left, right) {
    return { x: left.x + right.x, y: left.y + right.y };
}
export function subtract(left, right) {
    return { x: left.x - right.x, y: left.y - right.y };
}
export function scale(vector, factor) {
    if (!Number.isFinite(factor)) {
        throw new RangeError("Vector scale factor must be finite.");
    }
    return { x: vector.x * factor, y: vector.y * factor };
}
export function dot(left, right) {
    return left.x * right.x + left.y * right.y;
}
export function cross(left, right) {
    return left.x * right.y - left.y * right.x;
}
export function magnitudeSquared(vector) {
    return dot(vector, vector);
}
export function magnitude(vector) {
    return Math.hypot(vector.x, vector.y);
}
export function distance(left, right) {
    return magnitude(subtract(right, left));
}
export function normalize(vector) {
    const length = magnitude(vector);
    if (length === 0) {
        throw new RangeError("Cannot normalize a zero-length vector.");
    }
    return scale(vector, 1 / length);
}
export function normalizeOr(vector, fallback) {
    const length = magnitude(vector);
    return length === 0 ? normalize(fallback) : scale(vector, 1 / length);
}
export function leftNormal(vector) {
    return { x: -vector.y, y: vector.x };
}
export function rightNormal(vector) {
    return { x: vector.y, y: -vector.x };
}
export function lerp(start, end, ratio) {
    if (!Number.isFinite(ratio)) {
        throw new RangeError("Interpolation ratio must be finite.");
    }
    return {
        x: start.x + (end.x - start.x) * ratio,
        y: start.y + (end.y - start.y) * ratio,
    };
}
export function almostEqual(left, right, tolerance = 1e-9) {
    if (!Number.isFinite(tolerance) || tolerance < 0) {
        throw new RangeError("Tolerance must be a finite non-negative number.");
    }
    return distance(left, right) <= tolerance;
}
export function clamp(value, minimum, maximum) {
    if (!Number.isFinite(value) ||
        !Number.isFinite(minimum) ||
        !Number.isFinite(maximum) ||
        maximum < minimum) {
        throw new RangeError("Clamp values must be finite and maximum >= minimum.");
    }
    return Math.min(Math.max(value, minimum), maximum);
}
//# sourceMappingURL=vector.js.map